import { j as c } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const m = ({
  title: e,
  titleId: l,
  ...o
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...o,
    children: [
      e ? /* @__PURE__ */ c.jsx("title", { id: l, children: e }) : null,
      /* @__PURE__ */ c.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M405.329 469.329H213.35c-35.349 0-64.021-28.651-64.021-64V213.35c0-35.349 28.672-64.021 64.021-64.021h191.979c35.349 0 64 28.672 64 64.021v191.979c0 35.349-28.651 64-64 64m426.584 0H640.084c-35.392 0-64.085-28.693-64.085-64.085V213.415c0-35.392 28.693-64.085 64.085-64.085h191.829c35.392 0 64.085 28.693 64.085 64.085v191.829c0 35.392-28.693 64.085-64.085 64.085M406.308 877.871H214.479c-35.371 0-64.085-28.693-64.085-64.085V621.957c0-35.392 28.715-64.085 64.085-64.085h191.829c35.392 0 64.085 28.693 64.085 64.085v191.829c0 35.392-28.693 64.085-64.085 64.085m405.521 1.062H619.637c-35.285 0-63.915-28.608-63.915-63.893V622.827c0-35.285 28.629-63.893 63.915-63.893h192.192c35.285 0 63.893 28.608 63.893 63.893V815.04c0 35.285-28.608 63.893-63.893 63.893",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = i(m);
export {
  n as default
};
